import { render, staticRenderFns } from "./DialogAlterarDataVencimentoBoleto.vue?vue&type=template&id=6a8b51e0&"
import script from "./DialogAlterarDataVencimentoBoleto.vue?vue&type=script&lang=js&"
export * from "./DialogAlterarDataVencimentoBoleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports